"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(["\n    display: ", ";\n    margin-bottom: ", "em;\n    font-weight: bold;\n"], ["\n    display: ", ";\n    margin-bottom: ", "em;\n    font-weight: bold;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledLabel = _styledComponents2.default.label(_templateObject, function (props) {
    return props.inlineLabel ? "inline-block" : "block";
}, function (props) {
    return props.theme.input.margin / 2;
});

var FormLabel = function FormLabel(props) {
    return _react2.default.createElement(
        StyledLabel,
        _extends({ htmlFor: props.name }, props),
        props.children
    );
};

FormLabel.displayName = "FormLabel";

FormLabel.propTypes = {
    name: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    inlineLabel: _propTypes2.default.bool
};
FormLabel.defaultProps = {
    size: "default",
    expanded: false,
    inlineLabel: true
};
exports.default = FormLabel;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/form/label.js
// module id = 33
// module chunks = 95715928098905 168707334958949